import { useAppSelector } from 'hooks/useAppSelector';
import { PropsWithChildren, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { tradesBlottersPreferenceStateLoaded } from 'state/blotters/trades/tradesBlotters.actions';
import {
  selectTradesBlottersAreBlotterPreferencesInError,
  selectTradesBlottersType,
} from 'state/blotters/trades/tradesBlotters.selector';

import { emptyBlotterPreferences } from '../../shared/Blotter/Grid/blotter.model';
import { BlotterPreferencesLoadingErrorModal } from '../blotterPreferencesLoadingErrorModal';

export function PreferencesLoadingErrorModal({ children }: PropsWithChildren) {
  const dispatch = useDispatch();
  const type = useAppSelector(selectTradesBlottersType);

  const hasLoadingError = useAppSelector(state => selectTradesBlottersAreBlotterPreferencesInError(state, type));
  const onContinueAndDefault = useCallback(
    () => dispatch(tradesBlottersPreferenceStateLoaded(type, emptyBlotterPreferences)),
    [type, dispatch],
  );

  return (
    <BlotterPreferencesLoadingErrorModal hasLoadingError={hasLoadingError} onContinueAndDefault={onContinueAndDefault}>
      {children}
    </BlotterPreferencesLoadingErrorModal>
  );
}
